import React from 'react';
import {Col, Input, FormGroup, Label, Row } from 'reactstrap';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import {connect} from 'react-redux';
import * as PropTypes from 'prop-types';
import { updateHelpdeskMessage } from '../../store/actions';
import AhoyTrack from '../../modules/AhoyTrack';
import Button from '../Button/Button';

const HelpDeskForm = ({
  dispatchUpdateHelpdeskMessage,
  isHelpdeskMessageLoading,
  helpdeskMessage,
  imageSrc,
  currentEXLogo,
}) => {
  const extensionSchema = Yup.object().shape({
    support_email: Yup.string().email().required('Field is required'),
    self_harm_alert_email: Yup.string().email(),
    physical_danger_alert_email: Yup.string().email(),
  });

  AhoyTrack('button');

  return (
    <div className="settings-tab-block">
      <div className="title">
        Helpdesk Integration
        <p> Configure email addresses for escalation </p>
      </div>
      <div className="subtitle">
        Fill out the form below to set where HubbleIQ escalates help requests when
        it can't resolve a user's issue. These addresses will be used to generate
        tickets or send emails directly to your help desk or safety teams.
      </div>
      <Formik
        initialValues={{
          support_email: helpdeskMessage?.support_email || '',
          self_harm_alert_email: helpdeskMessage?.self_harm_alert_email || '',
          physical_danger_alert_email: helpdeskMessage?.physical_danger_alert_email || '',
        }}
        validationSchema={extensionSchema}
        onSubmit={(values) => dispatchUpdateHelpdeskMessage(values)}
        enableReinitialize
      >
        {({ handleChange, values, errors }) => (
          <Form className="form form-helpdesk">
            <Row>
              <Col xl="6">
                <div className="settings-tab-item">
                  <Row>
                    <Col md={9}>
                      <FormGroup>
                        <Label style={{ marginBottom: "10px" }} for="helpdesk-email">
                          <i className="mdi mdi-email-outline"> </i>
                          Helpdesk Email address
                        </Label>
                        <Input
                          id="helpdesk-email"
                          className={`form-control ${errors.support_email ? 'is-invalid' : ''}`}
                          name="support_email"
                          type="email"
                          onChange={(e) => handleChange(e)}
                          tag={Field}
                          disabled={isHelpdeskMessageLoading}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label style={{ marginBottom: "10px" }} for="helpdesk-email">
                          <i className="mdi mdi-email-outline"> </i>
                          Physical Danger Notifier
                        </Label>
                        <Input
                          id="physical-email"
                          className={`form-control ${errors.physical_danger_alert_email ? 'is-invalid' : ''}`}
                          name="physical_danger_alert_email"
                          type="email"
                          onChange={(e) => handleChange(e)}
                          tag={Field}
                          disabled={isHelpdeskMessageLoading}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label style={{ marginBottom: "10px" }} for="helpdesk-email">
                          <i className="mdi mdi-email-outline"> </i>
                          Self-Harm Notifier
                        </Label>
                        <Input
                          id="selfharm-email"
                          className={`form-control ${errors.self_harm_alert_email ? 'is-invalid' : ''}`}
                          name="self_harm_alert_email"
                          type="email"
                          onChange={(e) => handleChange(e)}
                          tag={Field}
                          disabled={isHelpdeskMessageLoading}
                        />
                      </FormGroup>
                      <div className="form-btn d-flex justify-content-between">
                        <Button type="submit" generalType="default" disabled={isHelpdeskMessageLoading}>Save changes</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
};

HelpDeskForm.defaultProps = {
};

HelpDeskForm.propTypes = {
  dispatchUpdateHelpdeskMessage: PropTypes.func.isRequired,
  isHelpdeskMessageLoading: PropTypes.bool.isRequired,
  helpdeskMessage: PropTypes.shape({
    chrome_head_request: PropTypes.string,
    chrome_sub_head_request: PropTypes.string,
    support_email: PropTypes.string,
    custom_redirect_url: PropTypes.string,
  }),
};

const mapStateToProps = (state) => {
  const {isHelpdeskMessageLoading, helpdeskMessage = {}} = state.EXConfig;
  return {isHelpdeskMessageLoading, helpdeskMessage};
};

const mapDispatchToProps = {
  dispatchUpdateHelpdeskMessage: updateHelpdeskMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpDeskForm);
